import { Injectable } from '@angular/core';
import * as componentActions from '@catdetails/actions/psf';
import {Store} from '@ngrx/store';
import {Observable} from "rxjs";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {FileDownloadInfo} from "@catcore/types/common";
import {FileBlobResponse} from "@catcore/utils";

@Injectable()
export class ProjectServiceFilesService {

  constructor(private http: HttpClient,
              private store: Store<any>) {
  }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PSF_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_PSF_DEACTIVATE});
  }

  downloadFile(serviceOrUnitConfig): Observable<any> {
    const url = serviceOrUnitConfig._links['action:download'].href;
    return this.fileDownload(url);
  }

  private fileDownload(url): Observable<FileDownloadInfo> {
    return this.http
      .get(url, {responseType: 'blob', observe: 'response'})
      .map((response: HttpResponse<Blob>) => {
        const fileResponse = new FileBlobResponse(response);
        return {blob: fileResponse.body, filename: fileResponse.filename};
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-service-files/services/project-service-files.service.ts